import { useEffect } from "react";

export default function GoogleAd() {
    useEffect(() => {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
            console.error("Erro ao carregar anúncio", e);
        }
    }, []);

    return (
        <ins className="adsbygoogle"
            style={{ display: "block", width: "100%", height: "250px" }}
            data-ad-client="ca-pub-4499890978757009"
            data-ad-slot="9320028188"
            data-ad-format="auto"
            data-full-width-responsive="true">
        </ins>
    );
}
